var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "acc-page-holder reset_pass_component" }, [
    _c(
      "div",
      { staticClass: "set-password ctsform reset_pass" },
      [
        _c(
          "h1",
          { key: "rp_ChangePassword", staticClass: "reset_pass_heading" },
          [_vm._v(_vm._s(_vm.$t("Account.ChangePassword.Heading")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control-block", class: { filled: _vm.newPassword } },
          [
            (_vm.showNewPassword ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPassword,
                      expression: "newPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.newPassword)
                      ? _vm._i(_vm.newPassword, null) > -1
                      : _vm.newPassword
                  },
                  on: {
                    focusout: function($event) {
                      !_vm.newPasswordField
                        ? (_vm.errorMessages.newPassMissing = true)
                        : (_vm.errorMessages.newPassMissing = false)
                    },
                    change: function($event) {
                      var $$a = _vm.newPassword,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.newPassword = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.newPassword = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.newPassword = $$c
                      }
                    }
                  }
                })
              : (_vm.showNewPassword ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPassword,
                      expression: "newPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.newPassword, null) },
                  on: {
                    focusout: function($event) {
                      !_vm.newPasswordField
                        ? (_vm.errorMessages.newPassMissing = true)
                        : (_vm.errorMessages.newPassMissing = false)
                    },
                    change: function($event) {
                      _vm.newPassword = null
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPassword,
                      expression: "newPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: _vm.showNewPassword ? "text" : "password"
                  },
                  domProps: { value: _vm.newPassword },
                  on: {
                    focusout: function($event) {
                      !_vm.newPasswordField
                        ? (_vm.errorMessages.newPassMissing = true)
                        : (_vm.errorMessages.newPassMissing = false)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newPassword = $event.target.value
                    }
                  }
                }),
            _vm._v(" "),
            _c(
              "label",
              { key: "rp_newPassword_label", staticClass: "control-label" },
              [_vm._v(_vm._s(_vm.$t("Account.ChangePassword.NewPassword")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "show_hide",
                class: { show_hide_hidden: _vm.showNewPassword },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toggleShowNewPassword()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.showNewPassword ? "Hide" : "Show"))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _vm.errorMessages.newPassMissing
            ? _c(
                "div",
                {
                  key: "rp_newPasswordMissing_error",
                  staticClass: "vmsg invalid"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "Account.ChangePassword.ErrorMessages.NewPasswordMissing"
                      )
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMessages.newPassStrength
            ? _c("div", {
                key: "pasl",
                staticClass: "vmsg invalid",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Account.Join.ErrorMsg.PassStrength", {
                      pwdMinLength: _vm.vldPasswordMinLength
                    })
                  )
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "control-block",
            class: { filled: _vm.confirmNewPassword }
          },
          [
            (_vm.showConfirmPassword ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmNewPassword,
                      expression: "confirmNewPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.confirmNewPassword)
                      ? _vm._i(_vm.confirmNewPassword, null) > -1
                      : _vm.confirmNewPassword
                  },
                  on: {
                    focusout: function($event) {
                      !_vm.confirmNewPasswordField
                        ? (_vm.errorMessages.confirmNewPassMissing = true)
                        : (_vm.errorMessages.confirmNewPassMissing = false)
                    },
                    change: function($event) {
                      var $$a = _vm.confirmNewPassword,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.confirmNewPassword = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmNewPassword = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmNewPassword = $$c
                      }
                    }
                  }
                })
              : (_vm.showConfirmPassword ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmNewPassword,
                      expression: "confirmNewPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.confirmNewPassword, null) },
                  on: {
                    focusout: function($event) {
                      !_vm.confirmNewPasswordField
                        ? (_vm.errorMessages.confirmNewPassMissing = true)
                        : (_vm.errorMessages.confirmNewPassMissing = false)
                    },
                    change: function($event) {
                      _vm.confirmNewPassword = null
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmNewPassword,
                      expression: "confirmNewPassword"
                    }
                  ],
                  attrs: {
                    autocomplete: "off",
                    maxlength: _vm.vldPasswordMaxLength,
                    type: _vm.showConfirmPassword ? "text" : "password"
                  },
                  domProps: { value: _vm.confirmNewPassword },
                  on: {
                    focusout: function($event) {
                      !_vm.confirmNewPasswordField
                        ? (_vm.errorMessages.confirmNewPassMissing = true)
                        : (_vm.errorMessages.confirmNewPassMissing = false)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.confirmNewPassword = $event.target.value
                    }
                  }
                }),
            _vm._v(" "),
            _c(
              "label",
              {
                key: "rp_confirmNewPassword_label",
                staticClass: "control-label"
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("Account.ChangePassword.ConfirmNewPassword"))
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "show_hide",
                class: { show_hide_hidden: _vm.showConfirmPassword },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toggleShowConfirmPassword()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.showConfirmPassword ? "Hide" : "Show"))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _vm.errorMessages.confirmNewPassMissing
            ? _c(
                "div",
                {
                  key: "rp_confirmNewPassword_Missing_error",
                  staticClass: "vmsg invalid"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.Missing"
                      )
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMessages.confirmedNewPassNotSame
            ? _c(
                "div",
                {
                  key: "rp_confirmNewPassword_NotSamePass_error",
                  staticClass: "vmsg invalid"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "Account.ChangePassword.ErrorMessages.ConfirmNewPassword.NotSame"
                      )
                    )
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.isSAModeZero
          ? _c("div", [
              _c(
                "div",
                { staticClass: "control-block", class: { filled: _vm.ssn } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ssn,
                        expression: "ssn"
                      }
                    ],
                    attrs: {
                      type: "text",
                      inputmode: "numeric",
                      autocomplete: "off",
                      maxlength: 4
                    },
                    domProps: { value: _vm.ssn },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.ssn = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Join.Last4SSN")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _vm.errorMessages.ssnNotDigit
                  ? _c(
                      "div",
                      {
                        staticClass: "vmsg invalid",
                        attrs: { id: "err_msg_ssn_not_digit" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.Join.ErrorMsg.Last4SSNNonDigit")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.errorMessages.ssnMissing
                  ? _c(
                      "div",
                      {
                        staticClass: "vmsg invalid",
                        attrs: { id: "err_msg_ssn_miss" }
                      },
                      [_vm._v(_vm._s(_vm.$t("Account.Join.ErrorMsg.Last4SSN")))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control-block",
                  class: { filled: _vm.dateOfBirth },
                  on: { click: _vm.onDateBirth }
                },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "datePickerMenu",
                      attrs: {
                        "close-on-click": false,
                        "close-on-content-click": false,
                        "nudge-right": 0,
                        "return-value": _vm.dateOfBirth,
                        lazy: "",
                        transition: "scale-transition",
                        "offset-y": "",
                        "full-width": "",
                        "min-width": "290px"
                      },
                      on: {
                        "update:returnValue": function($event) {
                          _vm.dateOfBirth = $event
                        },
                        "update:return-value": function($event) {
                          _vm.dateOfBirth = $event
                        }
                      },
                      model: {
                        value: _vm.datePickerMenu,
                        callback: function($$v) {
                          _vm.datePickerMenu = $$v
                        },
                        expression: "datePickerMenu"
                      }
                    },
                    [
                      _c("template", { slot: "activator" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.formattedDate,
                              expression: "formattedDate",
                              modifiers: { trim: true }
                            }
                          ],
                          attrs: {
                            type: "text",
                            id: "dateOfBirth",
                            autocomplete: "off",
                            readonly: "",
                            name: "reg-dob"
                          },
                          domProps: { value: _vm.formattedDate },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.formattedDate = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.$t("Account.Join.DOB")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-date-picker", {
                        ref: "picker",
                        attrs: {
                          max: _vm.maxDate,
                          "no-title": "",
                          scrollable: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.checkDateOfBirth()
                          }
                        },
                        model: {
                          value: _vm.dateOfBirthProp,
                          callback: function($$v) {
                            _vm.dateOfBirthProp = $$v
                          },
                          expression: "dateOfBirthProp"
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.errorMessages.dobMissing
                ? _c(
                    "div",
                    {
                      staticClass: "vmsg invalid",
                      attrs: { id: "err_msg_dateOfBirth_missing" }
                    },
                    [_vm._v(_vm._s(_vm.$t("Account.Join.ErrorMsg.MissingDOB")))]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeOne
          ? _c("div", { staticClass: "ctsform sa" }, [
              _c("form", [
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.secretQuestionOne))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.securityAnswer1 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer1,
                          expression: "securityAnswer1",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer1 },
                      on: {
                        focusout: function($event) {
                          !_vm.passwordSAObj.securityAnswer1
                            ? (_vm.errorMessages.securityAnswer1 = true)
                            : (_vm.errorMessages.securityAnswer1 = false)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer1 = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer1")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.errorMessages.securityAnswer1
                    ? _c("div", {
                        staticClass: "vmsg invalid",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("Account.Join.ErrorMsg.SecurityAnswer1")
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.securityAnswer1Length
                    ? _c("div", {
                        staticClass: "vmsg invalid",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.Join.ErrorMsg.SecurityAnswer1Length"
                            )
                          )
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "securityquestion" }, [
                  _vm._v(_vm._s(_vm.secretQuestionTwo))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: { filled: _vm.securityAnswer2 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.securityAnswer2,
                          expression: "securityAnswer2",
                          modifiers: { trim: true }
                        }
                      ],
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        maxlength: "50"
                      },
                      domProps: { value: _vm.securityAnswer2 },
                      on: {
                        focusout: function($event) {
                          !_vm.passwordSAObj.securityAnswer2
                            ? (_vm.errorMessages.securityAnswer2 = true)
                            : (_vm.errorMessages.securityAnswer2 = false)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.securityAnswer2 = $event.target.value.trim()
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer2")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm.errorMessages.securityAnswer2
                    ? _c("div", {
                        staticClass: "vmsg invalid",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("Account.Join.ErrorMsg.SecurityAnswer2")
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errorMessages.securityAnswer2Length
                    ? _c("div", {
                        staticClass: "vmsg invalid",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Account.Join.ErrorMsg.SecurityAnswer2Length"
                            )
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeTwo
          ? _c("div", { staticClass: "account-page ctsform sa mode-two" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Label")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pin container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.sendPINByTempSession()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block pin",
                      class: { filled: _vm.pin }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.pin,
                            expression: "pin",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.pin },
                        on: {
                          focusout: function($event) {
                            !_vm.passwordSAObj.saPin
                              ? (_vm.errorMessages.pin = true)
                              : (_vm.errorMessages.pin = false)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pin = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.errorMessages.pin
                ? _c("div", { staticClass: "vmsg invalid pin" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "Account.ChangePassword.ErrorMessages.PIN.Missing"
                        )
                      )
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeThree
          ? _c("div", { staticClass: "account-page ctsform sa pin-or-sq" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineOne")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "securityquestion" }, [
                _vm._v(_vm._s(_vm.secretQuestionOne))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control-block",
                  class: { filled: _vm.securityAnswer1ModeThree }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.securityAnswer1ModeThree,
                        expression: "securityAnswer1ModeThree",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.securityAnswer1ModeThree },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.securityAnswer1ModeThree = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer1")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "securityquestion" }, [
                _vm._v(_vm._s(_vm.secretQuestionTwo))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control-block",
                  class: { filled: _vm.securityAnswer2ModeThree }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.securityAnswer2ModeThree,
                        expression: "securityAnswer2ModeThree",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.securityAnswer2ModeThree },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.securityAnswer2ModeThree = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer2")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "or" }, [
                _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineTwo")))
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.PIN")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pin container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.sendPINByTempSession()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block pin",
                      class: { filled: _vm.pin }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.pin,
                            expression: "pin",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.pin },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pin = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeFour
          ? _c("div", { staticClass: "account-page ctsform sa pin-and-sq" }, [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.LineOne")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "securityquestion" }, [
                _vm._v(_vm._s(_vm.secretQuestionOne))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control-block",
                  class: { filled: _vm.securityAnswer1ModeFour }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.securityAnswer1ModeFour,
                        expression: "securityAnswer1ModeFour",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.securityAnswer1ModeFour },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.securityAnswer1ModeFour = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer1")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "securityquestion" }, [
                _vm._v(_vm._s(_vm.secretQuestionTwo))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "control-block",
                  class: { filled: _vm.securityAnswer2ModeFour }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.securityAnswer2ModeFour,
                        expression: "securityAnswer2ModeFour",
                        modifiers: { trim: true }
                      }
                    ],
                    attrs: {
                      type: "text",
                      autocomplete: "off",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.securityAnswer2ModeFour },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.securityAnswer2ModeFour = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.$t("Account.Join.SecurityAnswer2")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "or" }, [
                _vm._v(_vm._s(_vm.$t("MyAccount.SA.PinAndSA.LineTwo")))
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(_vm.$t("MyAccount.SA.PinOrSA.PIN")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pin container" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-btn-blue",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sendPINByTempSession()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Send")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "control-block pin",
                      class: { filled: _vm.pin }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.pin,
                            expression: "pin",
                            modifiers: { trim: true }
                          }
                        ],
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.pin },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.pin = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.$t("MyAccount.SA.Pin.Code")))
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeZero || _vm.isSAModeOne || _vm.isSAModeTwo
          ? _c(
              "div",
              { staticClass: "save-container" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "primary-btn-blue",
                    attrs: { "x-large": "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Account.ChangePassword.SetPassword"))
                      )
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeThree
          ? _c(
              "div",
              { staticClass: "save-container" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "primary-btn-blue",
                    attrs: {
                      "x-large": "",
                      disabled: !_vm.ModeThreeValidated()
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Account.ChangePassword.SetPassword"))
                      )
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isSAModeFour
          ? _c(
              "div",
              { staticClass: "save-container" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "primary-btn-blue",
                    attrs: {
                      "x-large": "",
                      disabled: !_vm.ModeFourValidated()
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.save()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Account.ChangePassword.SetPassword"))
                      )
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gotohome" },
          [
            _c(
              "v-btn",
              {
                staticClass: "primary-btn-blue",
                attrs: { "x-large": "" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.goToHomePage()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Account.ChangePassword.GoToHomepage")))
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ProcessingDialog",
          {
            attrs: {
              isDialogPersistent: true,
              isProcessing: _vm.isProcessing,
              isSuccess: !_vm.transactionError,
              processingTitle: _vm.$t(
                "Account.PersonalDetails.Dialog.Processing.Title"
              ),
              processingText: _vm.$t(
                "Account.PersonalDetails.Dialog.Processing.Text"
              ),
              successTitle: _vm.$t(
                "Account.ChangePassword.Dialog.Success.Title"
              ),
              successText: _vm.$t("Account.ChangePassword.Dialog.Success.Text"),
              errorTitle: _vm.$t("Account.ChangePassword.Dialog.Error.Title"),
              closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
            },
            model: {
              value: _vm.dialog,
              callback: function($$v) {
                _vm.dialog = $$v
              },
              expression: "dialog"
            }
          },
          [
            _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
              _vm.brandKey !== "sb"
                ? _c(
                    "p",
                    { staticClass: "generic-icon-note" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { color: "error" } },
                        [_vm._v("error")]
                      ),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Account.Join.Dialog.Error.Text")))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticClass: "response-error" }, [
                _vm._v(_vm._s(_vm.transactionError))
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(
                      "Account.ChangePassword.Dialog.Error.Text.ContactSupport"
                    )
                  )
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _vm.brandKey === "sb"
          ? _c("div", {
              staticClass: "vmsg customersupport",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("Account.ChangePassword.ContactCustomerSupport")
                )
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13114219", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13114219","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountSetPasswordByTempSession.vue
// module id = null
// module chunks = 